var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.69373 9.25221C5.3743 7.2105 7.285 5.83334 9.43715 5.83334H10.5629C12.715 5.83334 14.6257 7.21049 15.3063 9.2522L16.1396 11.7522C17.2189 14.9899 14.809 18.3333 11.3962 18.3333H8.60382C5.19103 18.3333 2.78118 14.9899 3.8604 11.7522L4.69373 9.25221Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7383 5.83332L8.26178 5.83332L7.09421 4.49412C5.94968 3.18135 7.28489 1.21914 8.95591 1.7582L9.72905 2.00761C9.90508 2.06439 10.095 2.06439 10.271 2.00761L11.0441 1.7582C12.7151 1.21914 14.0504 3.18135 12.9058 4.49412L11.7383 5.83332Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.1667C9.37866 15.2623 10.4815 15.287 12.5 14.1667",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBag);
export default __webpack_public_path__ + "static/media/money-bag.34450c62546d8fc9469ad4661dc4f06d.svg";
export { ForwardRef as ReactComponent };